import AccordionItem from 'components/v2/common/AccordionItem';
import RemoveProcessSummary from "./RemoveProcessSummary";
import RemoveProcessDetails from "./RemoveProcessDetails";

export default function RemoveProcess({removeProcess}) {
    return (
        <AccordionItem
                key={removeProcess.id}
                summaryComponent={<RemoveProcessSummary removeProcess={removeProcess}/>}>
            <RemoveProcessDetails removeProcess={removeProcess} />
        </AccordionItem>
    );
}
